// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3ZRa8","title":"ClientReferral_title__1tJpB","itemText":"ClientReferral_itemText__12CWx"};